import styled from '@emotion/styled'

export const FullBleedComponent = styled.section`
  width: 100vw;
  margin-left: 50%;
  transform: translateX(-50%);
`